import {
	createState,
} from './simpleDataList';

import {
	loadSitemapsRangeViaApi,
} from '~/model/sitemaps';



export const {
	loadData,
	reducer,
	selector,
} = createState(
	'invalidContentsSitemaps',
	(websiteId) => loadSitemapsRangeViaApi(websiteId, {
		'fields': 'url,number_of_errors',
		'filter[contains_minor_errors]': true,
		'offset': 0,
		'limit': 1000,
	}),
	30,
);
